import React from 'react';

import { Box, Flex, Show, Text } from '@chakra-ui/react';

import { TimelineSectionItem as TimelineSectionItemType } from '@/components/sections/services/typings';

type TimelineSectionItemProps = { isLast: boolean; index: number } & TimelineSectionItemType;

export const TimelineSectionItem = ({ header, description, isLast }: TimelineSectionItemProps) => {
  return (
    <Flex
      flexDir="column"
      flex={1}
      maxW={{
        base: '330px',
        sm: '380px',
        md: 'unset',
      }}
    >
      <Show above="md">
        <Flex mb={6} alignItems="center" position="relative">
          <Box w="12px" h="12px" borderRadius="50%" bgColor="white" zIndex={2} />
          <Box
            position="absolute"
            left="12px"
            right={
              isLast
                ? {
                    base: 0,
                    md: 0,
                    lg: 0,
                  }
                : {
                    base: -10,
                    md: -12,
                    lg: -16,
                  }
            }
            h="1px"
            sx={
              isLast
                ? {
                    background: 'linear-gradient(90deg, #FFFFFF 82.69%, rgba(255, 255, 255, 0) 100%)',
                  }
                : {}
            }
            bgColor={isLast ? 'transparent' : 'white'}
          />
        </Flex>
      </Show>
      <Text variant="text-xl/lineHeight-8/font-medium" color="text.500" mb={1}>
        {header}
      </Text>
      <Text variant="text-md/lineHeight-6/font-normal" color="text.300">
        {description}
      </Text>
    </Flex>
  );
};
